/**
 * Defines an API for saving and retrieving UI state across sessions.
 */
define([
    "dojo/_base/declare"
], function (declare) {

    /**
     * @interface SessionDataService
     */
    return declare([], {

        /**
         * Saves the specified data under the given key
         *
         * @param key - the key that will be used to retrieve the data
         * @param data - the data to save.  This must be a JSON serializable object
         * @param immediate - an optional boolean which if true will force the save operation to be carried out
         *                    immediately, overriding any coalescing delay.
         */
        save: function (key, data, immediate) {
            throw new Error('not implemented');
        },

        /**
         * Immediately performs any pending save operations.
         */
        flush: function () {
            throw new Error('not implemented');
        },

        /**
         * This method retrieves the data stored under specified key.  It returns a Promise rather than the data itself.
         * When the data is available the Promise's callback will be called.  If the data is unavailable, for example no
         * data has been stored under the given key, then the Promise's error function will be called.
         *
         * @param key
         */
        retrieve: function (key) {
            throw new Error('not implemented');
        }
    });
});
